import { takeLatest } from "redux-saga/effects";
import * as WORKERS from "../workers/univers";
import { UNIVERS_GET_REQUEST_ACTION } from "../../actions/univers";

export function* watchSaga() {
  yield takeLatest(UNIVERS_GET_REQUEST_ACTION, WORKERS.getUniversData);
}
